export default {"src":"/_next/static/media/Mail.be5a9b2d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};